import { axiosHelper } from 'Services/AxiosHelper';
import { OnGetCardTransactionListModel } from 'Models';
import { onRegisterCardTransactionBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnRegisterCardTransaction';

const onRegisterCardTransaction = async (
  params: onRegisterCardTransactionBodyData
): Promise<OnGetCardTransactionListModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onRegisterCardTransaction;
